import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import axios from "./axios";
import { getFromS3, uploadToS3 } from "./files";
export const getFieldsValidations = _ref => {
  let {
    page,
    name,
    fieldType,
    count
  } = _ref;
  return axios.get('/customvalidations/v1', {
    params: {
      page,
      name,
      fieldType
    },
    headers: {
      count
    }
  });
};
export const getFieldValidation = id => axios.get(`/customvalidations/v1/${id}`).then(_ref2 => {
  let {
    data
  } = _ref2;
  if (data) return getFromS3(data.linkToCode).then(_ref3 => {
    let {
      data: code
    } = _ref3;
    return _objectSpread(_objectSpread({}, data), {}, {
      code
    });
  });
  throw new Error('No file Uploaded');
});
export const createFieldValidation = (data, file) => axios.post(`/customvalidations/v1`, data).then(_ref4 => {
  let {
    data
  } = _ref4;
  if (data) return uploadToS3(data.linkToUpload, file).then(() => data);
  throw new Error('No file Uploaded');
});
export const updateFieldValidation = (id, data, file) => axios.put(`/customvalidations/v1/${id}`, data).then(_ref5 => {
  let {
    data
  } = _ref5;
  if (data) return uploadToS3(data.linkToUpload, file).then(() => data);
  throw new Error('No file Uploaded');
});
export const deleteFieldValidation = id => axios.delete(`/customvalidations/v1/${id}`);